// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"d65a50f1","20":"1a80148e","38":"170bcb45","224":"1674f2c8","438":"170bcb45","536":"64a66066","614":"1a80148e","620":"e10502d7","624":"ac41040e","677":"2417d0de"}[chunkId] + ".chunk.css";
};